<template>
  <div class="Vragenlijst">
    <vraag
      v-if="huidigevraag"
      :vraag="huidigevraag.Vraag"
      :antwoordtype="huidigevraag.AntwoordType"
      :image="huidigevraag.Afbeelding"
      :audio="huidigevraag.Audio"
      :autonext="huidigevraag.AutoNext"
      :vraagid="huidigevraag.VraagId"
      :userid="huidigevraag.MedewerkerId"
      :vraagaanwezig="huidigevraag != null"
      :afbeeldingcode="huidigevraag.AfbeeldingCode"
      v-on:antwoord="antwoord"
    />
    <div v-if="huidigevraag == null && !loading" class="text-center">
      <h1 class="mb-12">
        Dit was de laatste vraag. Bedankt en misschien tot ziens.
      </h1>
      <v-btn class="mt-12" color="primary" href="https://www.cvneuropsychiatrie.nl/"
        >Afsluiten</v-btn
      >
    </div>
    <div v-if="albeantwoord" class="text-center">
      <h1 class="mb-12">De vragenlijst is al eerder ingevuld.</h1>
      <v-btn class="mt-12" color="primary" href="https://www.cvneuropsychiatrie.nl/"
        >Afsluiten</v-btn
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vraag from "@/components/VraagWeb.vue";

export default {
  name: "vragenlijst",
  components: {
    Vraag,
  },
  data() {
    return {
      vragen: [],
      huidigevraag: null,
      loading: true,
      vraagidx: 0,
      albeantwoord: false,
    };
  },
  methods: {
    getVragen: function () {
      let vragensessieId = this.$route.params.sessie;
      let authCode = null;
      if (this.$route.query.e) {
        // e => sessie bevat authcode uit email.
        vragensessieId = null;
        authCode = this.$route.params.sessie;
      }

      this.$api
        .pVragensessieGetStatus({
          VragensessieId: vragensessieId,
          AuthCode: authCode,
        })
        .then((response) => {
          if (response.data[0].Gereed) {
            this.albeantwoord = true;
          } else {
            this.albeantwoord = false;
            this.$api
              .pVragensessieGet({
                VragensessieId: vragensessieId,
                AuthCode: authCode,
              })
              .then((response) => {
                this.vragen = response.data;
                if (this.vragen.length > 0) {
                  this.huidigevraag = this.vragen[0];
                  this.vraagidx = 0;
                  this.loading = false;
                }
              });
          }
        });
    },
    saveAntwoord: function (antwoord) {
      this.$api
        .pAntwoordSaveWeb({
          AuthCode: this.$route.params.sessie,
          VraagId: this.huidigevraag.VraagId,
          UserId: this.huidigevraag.MedewerkerId,
          Antwoord: antwoord,
        })
        .then(() => {});
    },
    antwoord: function (a) {
      this.saveAntwoord(a);
      // Volgende vraag....
      if (this.vraagidx < this.vragen.length - 1) {
        this.vraagidx++;
        this.huidigevraag = this.vragen[this.vraagidx];
      } else {
        this.huidigevraag = null;
        this.$api.pSessieBeeindig({
          VragensessieId: this.$route.params.sessie,
          ConsoleNaam: null, // Null, want web
        });
      }
    },
    spreekAfsluiting: function () {
      var audio = new Audio("/audio/Afsluiting.mp3");
      audio.play();
    },
  },
  watch: {
    huidigevraag: function () {
      if (this.huidigevraag == null && !this.loading) {
        this.spreekAfsluiting();
      }
    },
  },
  created: function () {
    this.getVragen();
  },
};
</script>

<style scoped>
</style>